var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.errors),function(error){return _c('GlobalErrorSnackbar',{key:error.id,attrs:{"message":error.message},on:{"close":function($event){return _vm.removeError(error)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }